import React, {useState} from 'react';
import { handleAPIRequest } from "../../../api/api"; // Adjust the import to your actual file structure
import { toast, ToastContainer } from 'react-toastify'; // Ensure you have react-toastify installed
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for the toast notifications
import { useNavigate } from 'react-router-dom';
import Modal from "react-modal";
const StepConfirmation = ({ userInfo, documents, tag, amount,planId }) => {
  const navigate = useNavigate();
  const [termsText, setTermsText] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    name,
    phone,
    email,
    password,
    address,
    country,
    role,
    companyDetails,
    supplierDetails,
    donorDetails,
  } = userInfo;

  const modalSelection = () => {
    if (selectedOption === "agree") {
      setSelectedOption(null);
      setIsModalOpen(false);
     handleSubmit();
    } else {
      setSelectedOption(null);
      setIsModalOpen(false);
    }
  }
  const fetchTermsAndConditions = async () => {
    try {
      const response = await handleAPIRequest("get", "get-terms-and-conditions");
      if (response) {
        setTermsText(response.termsText || "No Terms & Conditions available.");
        setIsModalOpen(true); // Show modal when terms are fetched
      }
    } catch (error) {
      toast.error("Failed to fetch Terms & Conditions.");
    }
  };
  // Validate all fields before API call
  const validateFields = () => {
    if (
      !name || !phone || !email || !password || !address || !country || !role ||
      (role === 'company' && (!companyDetails.companyName || !companyDetails.regNo || !companyDetails.address)) ||
      (role === 'supplier' && (!supplierDetails.supplierName || !supplierDetails.regNo || !supplierDetails.address || !supplierDetails.country)) ||
      (role === 'donor' && (!donorDetails.donorName || !donorDetails.address)) ||
      documents.length === 0 ||
      !tag || !amount
    ) {
      toast.error('Please fill all fields before submitting.');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
  
    // Validate fields
    if (!validateFields()) return;

    // Create a FormData object
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('password_confirmation', password);
    formData.append('contact_no', phone);
    formData.append('contact_person', name);
    formData.append('user_address', address);
    formData.append('country', country);
    formData.append('registrationType', role);
    formData.append('plan_id', planId);
    // Append role-specific fields
    if (role === 'company') {
      formData.append('company_name', companyDetails.companyName);
      formData.append('company_registration_no', companyDetails.regNo);
      formData.append('company_address', companyDetails.address);
      formData.append('company_website', companyDetails.website);
    } else if (role === 'supplier') {
      formData.append('supplier_name', supplierDetails.supplierName);
      formData.append('supplier_category', supplierDetails.supplierCategory);
      formData.append('supplier_registration_no', supplierDetails.regNo);
      formData.append('supplier_address', supplierDetails.address);
      formData.append('supplier_website', supplierDetails.website);
      formData.append('supplier_country', supplierDetails.country);
    } else if (role === 'donor') {
      formData.append('donor_name', donorDetails.donorName);
      formData.append('donor_address', donorDetails.address);
      formData.append('donor_website', donorDetails.website);
    }

    // Append documents and tag
    if (documents.length > 0) {
      documents.forEach((doc) => {
        formData.append('payment_doc', doc); // Assuming doc is a File object
      });
    }
    formData.append('amount', amount);
    formData.append('payment_tag', tag);
    console.log('data',formData);
    try {
      const response = await handleAPIRequest('post', 'register', formData);
      if (response) {
        toast.success('Signup successful!');
        setTimeout(() => {
          navigate('/login'); // Redirect to login
        }, 2000);
      }
    } catch (error) {
      toast.error('An error occurred. Please try again later.');
    }
  };

  return (
    <div className="p-6 bg-white shadow-lg rounded-lg">
      {/* Heading */}
      <h3 className="text-3xl font-semibold mb-6 text-center text-blue-600">Confirm Your Information</h3>

      {/* Personal Information */}
      <div className="mb-4">
        <h4 className="font-semibold text-lg text-blue-500">Personal Information</h4>
        <p><strong>Name:</strong> {name}</p>
        <p><strong>Phone Number:</strong> {phone}</p>
        <p><strong>Email:</strong> {email}</p>
        <p><strong>Address:</strong> {address}</p>
        <p><strong>Country:</strong> {country}</p>
      </div>

      {/* Role Information */}
      <div className="mb-4">
        <h4 className="font-semibold text-lg text-blue-500">{role.charAt(0).toUpperCase() + role.slice(1)} Information</h4>
        {role === 'company' && (
          <div>
            <p><strong>Company Name:</strong> {companyDetails.companyName}</p>
            <p><strong>Registration Number:</strong> {companyDetails.regNo}</p>
            <p><strong>Company Address:</strong> {companyDetails.address}</p>
            <p><strong>Website:</strong> {companyDetails.website}</p>
          </div>
        )}
        {role === 'supplier' && (
          <div>
            <p><strong>Supplier Name:</strong> {supplierDetails.supplierName}</p>
            <p><strong>Supplier Category:</strong> {supplierDetails.supplierCategory}</p>
            <p><strong>Registration Number:</strong> {supplierDetails.regNo}</p>
            <p><strong>Supplier Address:</strong> {supplierDetails.address}</p>
            <p><strong>Supplier Country:</strong> {supplierDetails.country}</p>
          </div>
        )}
        {role === 'donor' && (
          <div>
            <p><strong>Donor Name:</strong> {donorDetails.donorName}</p>
            <p><strong>Donor Address:</strong> {donorDetails.address}</p>
            <p><strong>Website:</strong> {donorDetails.website}</p>
          </div>
        )}
      </div>

      {/* Documents and Tag */}
      <div className="mb-4">
        <h4 className="font-semibold text-lg text-blue-500">Documents and Tag</h4>
        {documents.length > 0 ? (
          documents.map((doc, index) => (
            <p key={index}><strong>Document Name:</strong> {doc.name}</p>
          ))
        ) : (
          <p>No documents uploaded.</p>
        )}
        <p><strong>Amount:</strong> {amount || 'No amount added'}</p>
        <p><strong>Tag:</strong> {tag || 'No tag added.'}</p>
      </div>

      {/* Submit Button */}
      <div className="flex justify-center mt-6">
        <button
          onClick={fetchTermsAndConditions}
          className="py-4 px-6 bg-black text-white font-bold rounded-lg hover:bg-gray-800"
        >
          Signup
        </button>
      </div>
 {/* Terms & Conditions Modal */}
 <Modal
      isOpen={isModalOpen}
      onRequestClose={() => setIsModalOpen(false)}
      className="fixed inset-0 flex items-center justify-center z-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 sm:w-3/4 md:w-2/3 lg:w-3/5 max-w-4xl h-auto max-h-[80vh] flex flex-col">
        {/* Title */}
        <h2 className="text-xl sm:text-2xl font-bold mb-4 text-center">
          Terms & Conditions
        </h2>

        {/* Scrollable Content */}
        <div className="flex-grow overflow-y-auto text-gray-700 p-2 border border-gray-300 rounded-md max-h-[50vh] text-sm sm:text-base">
          <div dangerouslySetInnerHTML={{ __html: termsText }} />
        </div>

        {/* Radio Options */}
        <div className="mt-4 space-y-2">
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="terms"
              value="agree"
              onChange={(e) => setSelectedOption(e.target.value)}
              className="w-4 h-4 text-green-600 focus:ring-green-500"
            />
            <span className="text-gray-800 text-sm sm:text-base">
              I Agree to the Terms & Conditions.
            </span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="terms"
              value="disagree"
              onChange={(e) => setSelectedOption(e.target.value)}
              className="w-4 h-4 text-red-600 focus:ring-red-500"
            />
            <span className="text-gray-800 text-sm sm:text-base">
              I Disagree with the Terms & Conditions.
            </span>
          </label>
        </div>

        {/* Submit Button */}
        <div className="flex justify-end mt-4">
         
          <button
            onClick={() => {
              modalSelection();
            }}
            disabled={!selectedOption}
            className={`ml-4 px-4 py-2 rounded-lg text-white ${
              selectedOption ? "bg-green-500 hover:bg-green-600" : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>


      <ToastContainer />
    </div>
  );
};

export default StepConfirmation;
